<template>
  <svg
    ref="tooltipTarget"
    :data-bs-toggle="tooltipText ? 'tooltip' : null"
    :data-bs-title="tooltipText || null"
    :alt="altText"
    :style="svgStyle"
    :class="props.class"
    aria-hidden="true"
  >
    <use :href="spriteLink"></use>
  </svg>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, Ref } from "vue";
import { Tooltip } from "bootstrap";

interface Props {
  icon: string;
  sprite?: string;
  title?: string;
  alt?: string;
  class?:string;
  foregroundColor?: string;
  backgroundColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
    sprite: "general",
});

const tooltipText: Ref<string | undefined> = ref(props.title);
const tooltipTarget: Ref<HTMLElement | null> = ref<HTMLElement | null>(null);
const altText: Ref<string> = ref(props.alt ?? "");

const spriteLink = computed(
    () =>
        "/custom/module/public/vbsr2/public/sprite_" +
    props.sprite +
    ".svg#sprite_vbs_" +
    (props.icon.startsWith("vbs_") ? props.icon.substring(4) : props.icon),
);

const svgStyle = computed(() => {
    let style;
    if (props.foregroundColor) {
        style = "--icon-foreground-color: " + props.foregroundColor + ";";
    }
    if (props.backgroundColor) {
        style += "--icon-background-color: " + props.backgroundColor + ";";
    }
    return style;
});

onMounted(() => {
    if (tooltipTarget.value && tooltipText.value) {
        new Tooltip(tooltipTarget.value);
    }
});
</script>
